module.exports = __webpack_public_path__ + "media/images/campaign_explain2-5e36e042c3a12b2f2460e905edd9fc3c.png";